var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tos-container",on:{"scroll":_vm.onScroll}},[_c('TypeBody',{staticClass:"flex flex-col gap-4 p-4",attrs:{"id":"tosContainer","tag":"div"},domProps:{"innerHTML":_vm._s(_vm.copy)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }